import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { CartLines } from "@/components/CartLines";
import { CartSummary } from "@/components/CartSummary";
import { useCart } from "@/context/Providers";

export default function CartPage() {
  const { items } = useCart();
  return (
    <>
      <Seo title="Your Cart | SHADC Dispensary" description="Review your SHADC Dispensary cart." path="/cart/" noindex />
      <div className="container-x py-12">
        <h1 className="text-4xl font-bold text-white sm:text-5xl" data-testid="cart-page-title">Your Cart</h1>
        {items.length ? (
          <div className="mt-8 grid gap-10 lg:grid-cols-[1.6fr_1fr]">
            <div className="card-surface px-5 sm:px-7"><CartLines /></div>
            <div className="card-surface h-fit p-6"><CartSummary /><Link to="/shop/" className="link-gold mt-4 inline-block text-sm" data-testid="cart-page-continue-link">← Continue shopping</Link></div>
          </div>
        ) : (
          <div className="card-surface mt-8 p-10 text-center" data-testid="cart-page-empty"><p className="text-lg text-white">Your cart is empty.</p><Link to="/shop/" className="btn-gold mt-6">Browse the menu</Link></div>
        )}
      </div>
    </>
  );
}
